// extracted by mini-css-extract-plugin
export var affirmative = "survey-answer-question-card-module--affirmative--Xj9Ie";
export var answer = "survey-answer-question-card-module--answer--G68-H";
export var budget = "survey-answer-question-card-module--budget--poD6J";
export var leftWrapper = "survey-answer-question-card-module--left-wrapper--s5-hf";
export var negative = "survey-answer-question-card-module--negative--h9b0o";
export var question = "survey-answer-question-card-module--question--1svpV";
export var rightWrapper = "survey-answer-question-card-module--right-wrapper--mcnnt";
export var style = "survey-answer-question-card-module--style--3D7e2";
export var surveyAnswerQuestionCard = "survey-answer-question-card-module--survey-answer-question-card--k+cEK";